export default "__VITE_ASSET__155a3d35__"